import type { ExtendedProfile, Profile } from '../../../../entities/post/models';

export function getProfileEngagementRate(profile: Profile): ExtendedProfile {
  const getEngagementRate = () => {
    return (
      ((Number(profile.totalLikes) +
        Number(profile.totalComments) +
        (Number(profile.totalShares) || 0)) /
        profile.followerCount /
        profile.postCount) *
      100
    );
  };

  return {
    ...profile,
    engagementRate: getEngagementRate(),
  };
}
